import React, { Component } from 'react'
import { ListGroupItem } from 'reactstrap'
import { ActionButton, } from './'
import assignToClass from '../../../../../../helpers/users/manageUsers/assignToClass'

class StudentRow extends Component {
  state = {
    loading: false,
    error: '',
  }

  handleClick = () => {
    const { student, notInClass, record } = this.props
    assignToClass(student, record, notInClass)
      .then(() => this.clear())
      .catch((err) => this.setState({loading: false, error: '!'}))
  }

  clear = () => this.setState({loading: false, error: ''})

  componentWillUnmount = () => this.clear = function(){}

  render() {
    const { student, notInClass, record } = this.props
    const { loading, error, } = this.state
    return (
      <ListGroupItem onClick={this.handleClick} className='m2clickable'>
        {student.fullName}
        <ActionButton notInClass={notInClass} loading={loading} error={error} />
      </ListGroupItem>
    )
  }
}

export default StudentRow


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/InfoCard/AssignBlockComponents/StudentRow.js